import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M10 8.64 15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"
}), 'PlayArrowOutlined');